import React from 'react';
export const HomeMap = React.lazy(() => import('./HomeMap'));